<template>

  <WordServiceRunDialog :enablePDF="enablePDF" :file-name="fileName" @show="showModal" @hide="onCloseModal" @onSubmit="sendWordServiceRunDialog" :job="job"
                        dialog-title="Gerar Orçamento Cymaco" :disabled-submit="disabledSubmit"
                        :header-title="headerTitle">

    <t-input radio :options="tipoOptions" hide-label label="Tipo de Geração" required v-model="form.tipo_proposta"/>

    <t-input
        v-model="form.titulo_orcamento"
        required
        label="Título do Orçamento"
        help="Informe um título para identificação deste orçamento."
    />

    <b-row>
      <t-input
          cols="4"
          v-model="form.implantacao_obra_quantidade"
          required
          accept-zero
          label="Qtd. Implantação"
          number
      />

      <t-input
          cols="4"
          v-model="form.implantacao_obra_valor"
          required
          accept-zero
          label="Vl. Implan."
          help="Valor da Implantação"
          money
      />

      <t-input
          cols="4"
          v-model="form.percentual_desconto_a_vista"
          required
          accept-zero
          percent
          label="Desc. à vista "
      />
    </b-row>

    <b-row>
      <b-col cols="12">
        <t-input radio :options="acabamentoOptions" v-model="form.tipo_acabamento" label="Acabamento"/>
      </b-col>
    </b-row>

    <b-row class="mt-3">
      <t-input
          cols="4"
          v-model="form.prazo_inicio_dias_uteis"
          required
          label="Prazo Início"
          small="Dias úteis"
          number
      />

      <t-input
          cols="4"
          v-model="form.prazo_obras_meses"
          required
          label="Prazo Obra"
          small="Meses"
          number
      />

      <t-input
          cols="4"
          v-model="form.prazo_obras_dias_uteis"
          required
          label="Prazo Obra"
          small="Dias úteis"
          number
      />
    </b-row>


   <div class="mt-2 pt-2 border-top">
      <b-form-checkbox v-model="enablePDF" switch>
        Gerar uma cópia em PDF?
        <t-help title="Marque se desejar exportar além de um versão Word outra versão em PDF."/>
      </b-form-checkbox>
    </div>

  </WordServiceRunDialog>

</template>
<script>
import WordVBAServiceMixin from "@/mixins/embeddable/resource/wordVBAServiceMixin";

export default {
  name: "CymacoQuoteWordServiceRunDialog",
  mixins: [WordVBAServiceMixin],
  data() {
    return {
      fields: ["titulo_orcamento",
        "tipo_proposta",
        "prazo_inicio_dias_uteis",
        "prazo_obras_meses",
        "prazo_obras_dias_uteis",
        "percentual_desconto_a_vista",
        "tipo_acabamento",
        "implantacao_obra_quantidade",
        "implantacao_obra_valor",
        "origem_rotina_servico"],
      form: {
        titulo_orcamento: "Reformas Gerais",
        tipo_proposta: "C", // C = Comercial
        prazo_inicio_dias_uteis: 10,
        prazo_obras_meses: 4,
        prazo_obras_dias_uteis: 90,
        percentual_desconto_a_vista: 3,
        tipo_acabamento: "P", // P = Proteção Total
        implantacao_obra_quantidade: 1,
        implantacao_obra_valor: 1000,
        origem_rotina_servico: "S"
      },
      tipoOptions: [
        {text: "Proposta Comercial", value: "C"},
        {text: "Proposta Técnica", value: "T"}
      ],
      acabamentoOptions: [
        {text: "Proteção Total", value: "P"},
        {text: "Acrílico Fosco", value: "N"},
        {text: "Nano Rocha", value: "A"}
      ]

    }
  },
  methods: {
    //Declaro sempre localmente, pois poderá realizar operações diferentes do padrão como setar algum valor padrão vindo de fora e que seria limpo pelo resetModal de forma dinamica
    async showModal() {
        this.headerTitle = "Orçamento nº " + this.item.quoteCodeLabel
        this.fileName = "orcamento_" + this.item.quoteCodeLabel
        this.job = {}
    }
  }
}
</script>
